/** A finger, not a mouse: phones and tablets (also the Tafo app and the Sunmi). */
export const touchScreen = (): boolean =>
  typeof window.matchMedia === "function" && window.matchMedia("(hover: none) and (pointer: coarse)").matches;
